import { League } from "../../contracts";
import { getURLName } from "../getURLName";

export const mapLeagueUrl = (ajustPath: Function, league: League): League => {
    const urlParams = `${getURLName(league.sportName)}/${getURLName(league.name)}`;
    league.linkUrl = ajustPath(urlParams);
    return league;
}